/**
 * @generated SignedSource<<eb377262c43da0ed8a2764139eefa43b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvitationAuthMode = "SIGN_IN" | "SIGN_UP" | "%future added value";
export type AuthRouteInvitationQuery$variables = {
  id: string;
};
export type AuthRouteInvitationQuery$data = {
  readonly invitation: {
    readonly authMode: InvitationAuthMode;
    readonly email: string;
    readonly id: string;
    readonly organizationName: string;
    readonly " $fragmentSpreads": FragmentRefs<"InvitationHeaderFragment" | "InvitationPageFragment">;
  } | null | undefined;
};
export type AuthRouteInvitationQuery = {
  response: AuthRouteInvitationQuery$data;
  variables: AuthRouteInvitationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authMode",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthRouteInvitationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Invitation",
        "kind": "LinkedField",
        "name": "invitation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InvitationHeaderFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InvitationPageFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AuthRouteInvitationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Invitation",
        "kind": "LinkedField",
        "name": "invitation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inviterName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "314ccf03b728eb98f4617a63ee7bf7ce",
    "id": null,
    "metadata": {},
    "name": "AuthRouteInvitationQuery",
    "operationKind": "query",
    "text": "query AuthRouteInvitationQuery(\n  $id: UUID!\n) {\n  invitation(id: $id) {\n    id\n    email\n    authMode\n    organizationName\n    ...InvitationHeaderFragment\n    ...InvitationPageFragment\n  }\n}\n\nfragment InvitationHeaderFragment on Invitation {\n  email\n  role\n  inviterName\n  organizationName\n}\n\nfragment InvitationPageFragment on Invitation {\n  id\n  email\n  role\n  organizationName\n  inviterName\n}\n"
  }
};
})();

(node as any).hash = "5293b8bc42c3cb5ace7135d6845d41da";

export default node;
